namespace Solovis.Reports.ParameterTypes {

  export var _parameterTypeToParameterControlMap = {

    "annualizationMethod": "Solovis.Reports.Parameters.AnnualizationMethodParameterControl",

    "assetSelectionSet": "Solovis.Reports.Parameters.AssetSelectionSetParameterControl",

    "bool": "Solovis.Reports.Parameters.BoolParameterControl",

    "choice": "Solovis.Reports.Parameters.ChoiceParameterControl",

    "columnSelector": "Solovis.Reports.Parameters.ColumnSelectorParameterControl",

    "compositeSelectionSet": "Solovis.Reports.Parameters.Composites.CompositeSelectionSetParameterControl",

    "contact": "Solovis.Reports.Parameters.ContactParameterControl",

    "currency": "Solovis.Reports.Parameters.CurrencyParameterControl",

    "currencyPair": "Solovis.Reports.Parameters.CurrencyPairParameterControl",

    "dateIndex": "Solovis.Reports.Parameters.DateIndexParameterControl",

    "decimal": "Solovis.Reports.Parameters.DecimalParameterControl",

    "entity": "Solovis.Reports.Parameters.EntityParameterControl",

    "entityOrInvestment": "Solovis.Reports.Parameters.EntityOrInvestmentParameterControl",

    "exposureProfile": "Solovis.Reports.Parameters.ExposureProfileParameterControl",

    "integer": "Solovis.Reports.Parameters.IntegerParameterControl",

    "intervalSet": "Solovis.Reports.Parameters.IntervalSetParameterControl",

    "investment": "Solovis.Reports.Parameters.InvestmentParameterControl",

    "liquidityModel": "Solovis.Reports.Parameters.LiquidityModelParameterControl",

    "manager": "Solovis.Reports.Parameters.ManagerParameterControl",

    "nbdCalendar": "Solovis.Reports.Parameters.NbdCalendarParameterControl",

    "note": "Solovis.Reports.Parameters.NoteParameterControl",

    "numberPeriods": "Solovis.Reports.Parameters.ForwardPeriodsParameterControl",

    "property": "Solovis.Reports.Parameters.PropertyParameterControl",

    "report": "Solovis.Reports.Parameters.ReportParameterControl",

    "sourceData": "Solovis.Reports.Parameters.SourceDataParameterControl",

    "statSet": "Solovis.Reports.Parameters.Stats.StatSetParameterControl",

    "string": "Solovis.Reports.Parameters.StringParameterControl",

    "tag": "Solovis.Reports.Parameters.TagParameterControl",

    "tagSet": "Solovis.Reports.Parameters.TagSetParameterControl",

    "timePeriods": "Solovis.Reports.Parameters.TimePeriodsParameterControl",

    "transaction": "Solovis.Reports.Parameters.TransactionParameterControl",

    "user": "Solovis.Reports.Parameters.UserParameterControl",

    "utcTimestamp": "Solovis.Reports.Parameters.UtcTimestampParameterControl",

    "valueType": "Solovis.Reports.Parameters.ValueTypeParameterControl",

    "horizonPerformanceAdvancedOptions": "Solovis.Reports.Parameters.HorizonPerformance.AdvancedOptionsParameterControl",
  };


  /**
   * Retrieve type name for control for editing parameter of specified parameter type.
   * @param parameterType
   */
  export function getParameterControlForParameterType(parameterType: string): string {
    if (this._parameterTypeToParameterControlMap[parameterType]) {
      return this._parameterTypeToParameterControlMap[parameterType];
    }
    else {
      throw "No parameter control registered for parameter type: " + parameterType;
    }
  }

  /**
   * Returns the list of parameter types available in the system.
   * This list is dynamically built based on enabled feature flags.
   */
  export function getParameterTypeList(): string[] {
    var list: string[] = [];
    for (var key in this._parameterTypeToParameterControlMap) {
      // Skip manager parameter only if feature flag is explicitly false
      if (key === "manager" && (Solovis as any).Info.userEligibleForManagerAsObject === false) {
        continue;
      }
      list.push(key);
    };

    return list;
  }
}
